<template>
  <!-- AVA-792: the one Linked / Other / No Link toggle every tag list uses (FR-043). -->
  <div class="avail-scope-toggle" role="group" aria-label="Link status">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      class="avail-toggle-btn"
      :class="{ active: selected.includes(opt.value) }"
      :aria-pressed="String(selected.includes(opt.value))"
      :title="opt.tooltip"
      @click="toggle(opt.value)">
      <v-icon :size="iconSize" class="mr-1">{{ opt.icon }}</v-icon>
      {{ opt.label }}
    </button>
  </div>
</template>

<script>
  import { log } from '@/utils/debugLogger';

  // Values match the backend LinkStatus enum (MODS.Forge.Models/Models/Tags/LinkStatus.cs), sent as
  // ?linkStatus=Linked&linkStatus=Other. The server rule is SqlUtils.WhereLinkStatus, for every tag type.
  export const LINK_STATUS_OPTIONS = Object.freeze([
    { label: 'Linked', value: 'Linked', icon: 'mdi-link-variant', tooltip: 'Placed in this facility, and every tag that belongs to this facility' },
    { label: 'Other', value: 'Other', icon: 'mdi-domain', tooltip: 'Master or shared tags placed only in another facility of the group' },
    { label: 'No Link', value: 'NoLink', icon: 'mdi-link-variant-off', tooltip: 'Master or shared tags not placed anywhere yet' },
  ]);
  const ALL_LINK_STATUSES = LINK_STATUS_OPTIONS.map((opt) => opt.value);

  export default {
    name: 'LinkStatusToggle',
    props: {
      iconSize: { type: [Number, String], default: 14 },
    },
    data() {
      return { options: LINK_STATUS_OPTIONS };
    },
    computed: {
      selected() {
        return this.$store.getters['TAGS_REGISTER/GET_LINK_STATUS_FILTER'] || [];
      },
    },
    methods: {
      toggle(value) {
        const next = this.selected.includes(value)
          ? this.selected.filter((v) => v !== value)
          : [...this.selected, value];
        // Deselecting everything means "show all", never an empty list.
        this.$store.commit('TAGS_REGISTER/SET_LINK_STATUS_FILTER', next.length ? next : ALL_LINK_STATUSES);
        log('LinkStatusToggle', `Link-status filter: active=[${(next.length ? next : ALL_LINK_STATUSES).join(', ')}]`);
      },
    },
  };
</script>

<style scoped>
  .avail-scope-toggle {
    display: flex;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    padding: 4px;
  }

  .avail-toggle-btn {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    border: none;
    background: transparent;
    border-radius: 0;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.5);
    transition: all 0.2s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    justify-content: center;
    min-width: 0;
  }

  .avail-toggle-btn:hover {
    color: rgba(0, 0, 0, 0.75);
  }

  .avail-toggle-btn:first-child {
    border-radius: 5px 0 0 5px;
  }

  .avail-toggle-btn:last-child {
    border-radius: 0 5px 5px 0;
  }

  .avail-toggle-btn.active {
    background: white;
    color: var(--v-primary-base, #03624c);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  }

  .theme--dark .avail-scope-toggle {
    background: rgba(255, 255, 255, 0.05);
  }

  .theme--dark .avail-toggle-btn {
    color: rgba(255, 255, 255, 0.5);
  }

  .theme--dark .avail-toggle-btn:hover {
    color: rgba(255, 255, 255, 0.75);
  }

  .theme--dark .avail-toggle-btn.active {
    background: var(--v-bg3-base, #303030);
    color: var(--v-primary-base, #03624c);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
</style>
